export class LeadRequest {
    key: string;
    sourceUrl: string;
    answers: { Key: string, Value: string }[];

    constructor(key: string, sourceUrl: string, answers: { Key: string, Value: string }[]) {
        this.key = key;
        this.sourceUrl = sourceUrl;
        this.answers = answers;
    }
}
